const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_id",
];

export function initUTMTracking() {
  const params = new URLSearchParams(window.location.search);

  UTM_KEYS.forEach((key) => {
    const value = params.get(key);

    if (value && !sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, value);
    }
  });
}

export function appendUTMData(formData) {
  UTM_KEYS.forEach((key) => {
    formData.set(key, sessionStorage.getItem(key) || "");
  });

  formData.set("url_origen", window.location.href);
}